// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__2tqnr","fileBtn":"File_fileBtn__18bzx","closeBtn":"File_closeBtn__3NVjm","fileSelected":"File_fileSelected__1xERP","disabled":"File_disabled__wKNO6"};